<template>
    <Card :bodyStyle="bodyStyle" :bordered="true" class="theme-card-border mb-4">
        <div v-if="title" class="theme-card-title">
            <h4 class="text-primary" :style="{ marginBottom: 0 }" v-if="headerSize=='small'">
                <span>{{ title }}</span>
                <a herf="javascript:void(0)" v-if="data.collapsed" @click="() => onUpdateCollapsed(false)">
                    <CIcon class="ml-2 text-14" file="caret-up.svg"></CIcon>
                    <span class="ml-2 text-12">({{ $t("button.hide") }})</span>
                </a>
                <a herf="javascript:void(0)" v-else @click="() => onUpdateCollapsed(true)">
                    <CIcon class="ml-2 text-14" file="caret-down.svg"></CIcon>
                    <span class="ml-2 text-12">({{ $t("button.show") }})</span>
                </a>
            </h4>
            <h2 class="text-primary" v-else>
                <span>{{ title }}</span>
                <a herf="javascript:void(0)" v-if="data.collapsed" @click="() => onUpdateCollapsed(false)">
                    <CIcon class="ml-2 text-14" file="caret-up.svg"></CIcon>
                    <span class="ml-2 text-12">({{ $t("button.hide") }})</span>
                </a>
                <a herf="javascript:void(0)" v-else @click="() => onUpdateCollapsed(true)">
                    <CIcon class="ml-2 text-14" file="caret-down.svg"></CIcon>
                    <span class="ml-2 text-12">({{ $t("button.show") }})</span>
                </a>
            </h2>
        </div>
        <div :style="{ display: data.collapsed ? 'none' : 'block' }">
            <Skeleton v-if="isLoading" />
            <template v-else>
                <slot></slot>
            </template>
        </div>
    </Card>
</template>

<script>
import { defineComponent, defineAsyncComponent, reactive } from "vue";
import { Card, Skeleton } from "ant-design-vue";

export default defineComponent({
    components: {
        Card,
        Skeleton,
        CIcon: defineAsyncComponent(() => import("../icon/CIcon")),
    },
    props: {
        title: {},
        isLoading: { default: false },
        collapsed: { default: false },
        headerSize: { default: ""},
        bodyStyle: { default: {} }
    },
    emits: ["update:collapsed"],
    setup(props, { emit }) {
        const data = reactive({ collapsed: props.collapsed });
        const onUpdateCollapsed = (collapsed) => {
            data.collapsed = collapsed;
            emit("update:collapsed", collapsed);
        };
        return { props, data, onUpdateCollapsed };
    },
});
</script>